import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import ContractDataModal from '../ActionModals/ContractDataModal'
import { hideReduxModal, showReduxModal } from '../../../Reducers/UI/actions'
import { updateContractData } from '../../../Containers/City/Page/Ambasador/gql'
import { useEffect } from 'react'

const useContractData = (ambassador, user, setGermanyContract) => {
  const dispatch = useDispatch()
  let contractDataInitial = {
    name: 'Contract data',
    isCustomData: true,
  }

  const [contractData, setContractData] = useState(null)

  useEffect(() => {
    if (ambassador.germanyContractData) {
      contractDataInitial = {
        ...contractDataInitial,
        ...ambassador.germanyContractData,
        uploader: ambassador.email,
        url: 'modal',
        updatedAt: new Date(ambassador.germanyContractData.updatedAt),
        actorId: +user.id,
      }
      setContractData(contractDataInitial)
    } else {
      setContractData({
        name: 'Contract data',
        isCustomData: true,
      })
    }
  }, [ambassador])

  const openContractDataModal = () => {
    return dispatch(
      showReduxModal({
        children: (
          <ContractDataModal
            ambassador={ambassador}
            contractData={contractData}
            onClose={() => {
              dispatch(hideReduxModal())
            }}
          />
        ),
        onConfirm: () => dispatch(hideReduxModal()),
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'contract',
      }),
    )
  }

  const handleContractDataChange = async ({ document, input, isEdit }) => {
    try {
      await updateContractData(input)
      setContractData({ ...document, ...input, isEdit })
    } catch (error) {
      console.error({ error })
    }
  }

  const onContractDataStatusChange = async ({
    document,
    status,
    rejectReason,
  }) => {
    const input = { userId: ambassador.id, status, rejectReason }
    await handleContractDataChange({ document, input })
    setGermanyContract({ ...document, status })
  }

  const onContractDataEdit = data => {
    setContractData(prevInfo => ({ ...prevInfo, data, isEdit: true }))
  }

  const onContractDataSave = document => {
    handleContractDataChange({
      document,
      input: {
        userId: ambassador.id,
        comment: contractData.comment,
        actorId: +user.id,
      },
      isEdit: false,
    })
  }

  return {
    openContractDataModal,
    contractData,
    onContractDataEdit,
    onContractDataSave,
    onContractDataStatusChange,
    setContractData,
  }
}

export default useContractData
